<ng-content></ng-content>
@if (url()) {
  <a href="javascript:void(0)" class="content hasnt-color" onclick="">{{ label() }}</a>
}
@if (!url()) {
  <span class="content hasnt-color">{{ label() }}</span>
}
